import KeyFlowVO from 'commons/vo/KeyFlowVO';

export type PreferenceVOProps = {
  ID: number;
  PID: number;
  NAME: string;
  VALUE: string;
  DESCRIPTION: string;
  CREATEDATE: string;
  CREATEUSER: string;
  MODIFYDATE: string;
};

class PreferenceVO extends KeyFlowVO {
  id: number;
  pid: number;
  name: string;
  value: string;
  description: string;
  createDate: string;
  createUser: string;
  modifyDate: string;

  constructor(data: PreferenceVOProps) {
    super(data);
    this.id = data.ID;
    this.pid = data.PID;
    this.name = data.NAME;
    this.value = data.VALUE;
    this.description = data.DESCRIPTION;
    this.createDate = data.CREATEDATE;
    this.createUser = data.CREATEUSER;
    this.modifyDate = data.MODIFYDATE;
  }

  get toStringValue() {
    return this.value ? String(this.value) : '';
  }

  get toNumberValue() {
    return this.value ? Number(this.value) : 0;
  }
}

export default PreferenceVO;
